import React, { ChangeEventHandler, FC } from 'react'
import styles from './Cart.module.css'
import classNames from 'classnames'
import { IProduct } from '../../../types/IProduct'
import { useCart } from '../../../contexts/CartContext'
import { getPrice } from '../../../libs/common'
import Icon from '../../units/Icon'

interface ICartRowProps {
  product: IProduct
  quantity: number
  isOrder?: boolean
}

const CartRow: FC<ICartRowProps> = (props) => {
  const { product, quantity, isOrder } = props
  const cart = useCart()

  const { totalPrice } = {
    totalPrice: product.cost,
  }

  const handleRemoveCart = () => {
    cart.removeFromCart(product.id)
  }

  const handleUpdateQuantity: ChangeEventHandler<HTMLInputElement> = (event) => {
    cart.updateCartProduct(product.id, Number(event.target.value || '0'))
  }

  const handleBlur: ChangeEventHandler<HTMLInputElement> = (event) => {
    cart.updateCartProduct(product.id, Number(event.target.value || '1'))
  }

  const handleChangeQuantity = (value: number) => {
    cart.updateCartProduct(product.id, value)
  }

  return (
    <li key={product.id} className={classNames(styles.cartProduct, { [styles.orderRow]: isOrder })}>
      <div className={styles.cartProductLeft}>
        <img src={product.images[0].original} width={32} height={32} alt="" />
      </div>
      <div className={styles.cartProductContent}>
        <span className={styles.name}>
          {product.name}
          <button type="button" className={styles.cartRemoveProductButton} onClick={handleRemoveCart}>
            <Icon hash="trash" size={20} />
          </button>
        </span>
        <div className={styles.cartProductRight}>
          <div className={styles.cartProductValues}>
            <button
              type="button"
              className={styles.quantityButton}
              onClick={() => handleChangeQuantity(Math.max(1, quantity - 1))}
            >
              <Icon hash="minus" size={24} />
            </button>
            <input min={1} type="tel" value={quantity || ''} onChange={handleUpdateQuantity} onBlur={handleBlur} />
            <button
              type="button"
              className={styles.quantityButton}
              onClick={() => handleChangeQuantity(Math.min(99, quantity + 1))}
            >
              <Icon hash="plus" size={24} />
            </button>
          </div>
          <div className={styles.cartProductPrice}>{totalPrice && <b>{getPrice(totalPrice * quantity)}</b>}</div>
        </div>
      </div>
    </li>
  )
}

export default CartRow
